import { isSSR } from 'utils';

export const isProduction = (): boolean | undefined => {
  if (!isSSR) {
    return window.location.hostname.includes('stellartech.se');
  }
};
